import styled from 'styled-components';

const Icon = styled.svg`
  display: inline-block;
  vertical-align: middle;
`;

export default { Icon };
